module.exports = __webpack_public_path__ + "static/media/talk00_small.de75fa0b.jpg";